import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  HostListener,
  inject,
  signal,
} from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import {
  LanguagesSystem,
  LocalStorageEnum,
  StorageService,
} from '@olymp/shared';

@Component({
  selector: 'lib-language',
  imports: [TranslocoPipe],
  templateUrl: './language.html',
  styleUrl: './language.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Language {
  private readonly host = inject(ElementRef<HTMLElement>);
  $translocoService = inject(TranslocoService);
  $storageService = inject(StorageService);

  readonly open = signal(false);
  activeLang = signal<string>(this.$translocoService.getActiveLang());

  private readonly flagByLang: Record<string, string> = {
    uz: './images/flags/uz.svg',
    ru: './images/flags/ru.svg',
    en: './images/flags/en.svg',
    kaa: './images/flags/kaa.svg',
  };

  avaiLableLang = (
    Object.keys(LanguagesSystem) as Array<keyof typeof LanguagesSystem>
  ).map((key) => ({
    label: key,
    value: LanguagesSystem[key],
    flag: this.flagByLang[LanguagesSystem[key]] ?? '',
  }));

  readonly activeFlag = computed(() => this.flagByLang[this.activeLang()] ?? '');

  toggle(): void {
    this.open.update((v) => !v);
  }

  close(): void {
    this.open.set(false);
  }

  selectLanguage(lang: string): void {
    this.$storageService.set(LocalStorageEnum.Language, lang);
    this.$translocoService.setActiveLang(lang);
    this.activeLang.set(lang);
    this.close();
  }

  @HostListener('document:click', ['$event'])
  protected onDocumentClick(event: MouseEvent): void {
    if (this.open() && !this.host.nativeElement.contains(event.target)) {
      this.close();
    }
  }

  @HostListener('document:keydown.escape')
  protected onEscape(): void {
    this.close();
  }
}
